<template lang="pug">
.row
  .col-md-2

  .col-md-8
    h1 Edit {{squeueStore.squeue.title}}

    LoaderOverlay(:loading="loading")
      Form(:squeue="squeueStore.squeue")

  .col-md-2
</template>

<script>
  import { mapStores } from 'pinia'
  import { useSqueueStore } from '@/stores/squeue'

  import Form from '../shared/form.vue'
  import LoaderOverlay from '@/components/shared/loader_overlay.vue'

  export default {
    components: {
      Form,
      LoaderOverlay
    },

    props: {
      squeueId: {
        type: Number,
        required: true
      }
    },

    computed: {
      ...mapStores(useSqueueStore)
    },

    data() {
      return {
        loading: true
      }
    },

    async mounted() {
      this.loading = true

      const { squeueId } = this
      await this.squeueStore.fetch({ squeueId })

      this.loading = false
    }
  }
</script>
